import {DvLayout, EditInfo, LayoutViewMode} from "@dv5/domain"
import type {CSSProperties} from 'react'
import {getContrastTextColor} from "./colorService"

/**
 * Service for managing layout styles
 */
class LayoutStylesService {
  /**
   * Gets layout styles with the specified zoom level
   * @param zoom The zoom level to apply
   * @returns CSSProperties object with zoom applied
   */
  getLayoutStyles(zoom: number): CSSProperties {
    return {
      zoom: zoom / 100.0
    }
  }

  getLayoutBackground(backgroundColor: string, viewMode: LayoutViewMode): string {
    if (viewMode === LayoutViewMode.FOCUS || viewMode === LayoutViewMode.FULL_PAGE) {
      return `#FFFFFF`
    }
    return backgroundColor ? (backgroundColor === 'transparent' ? backgroundColor : backgroundColor + '66') : ''
  }

  getLayoutBorder(backgroundColor: string, viewMode: LayoutViewMode, current: boolean): string {
    if (viewMode === LayoutViewMode.FOCUS || viewMode === LayoutViewMode.FULL_PAGE) {
      return backgroundColor ? (backgroundColor === 'transparent' ? backgroundColor : backgroundColor) : ''
    }
    if (current) {
      return backgroundColor ? backgroundColor : ''
    }
    return ''
  }

  getLayoutClasses(layout: DvLayout,
                   isCurrentLayout: boolean,
                   viewMode: LayoutViewMode,
                   editInfo: EditInfo
                   ): Array<String> {
    const classes = ['dvLayout']
    if (layout.children.length === 0) {
      classes.push('noChildren')
    }
    if (isCurrentLayout) {
      classes.push('active')
    }
    if (viewMode === LayoutViewMode.FOCUS) {
      classes.push('expanded')
    }
    if (viewMode === LayoutViewMode.FULL_PAGE) {
      classes.push('fullpage')
    }
    if (editInfo.editing || editInfo.itemInfo || editInfo.groupInfo) {
      classes.push('editing')
    }
    return classes
  }

  getToolbarBgColor(layout: DvLayout, isCurrentLayout: boolean, viewMode = LayoutViewMode.NORMAL) {
    if (viewMode === LayoutViewMode.FULL_PAGE) {
      return 'transparent'
    }
    if (layout.backgroundColor && layout.backgroundColor.startsWith('#')) {
      return layout.backgroundColor + (isCurrentLayout ? '' : '66')
    }
    return ''
  }

  getToolbarFgColor(layout: DvLayout, isCurrentLayout: boolean, viewMode = LayoutViewMode.NORMAL) {
    if (viewMode === LayoutViewMode.FULL_PAGE) {
      return getContrastTextColor('#FFFFFF')
    }
    if (layout.backgroundColor && layout.backgroundColor.startsWith('#')) {
      return getContrastTextColor(layout.backgroundColor)
    }
    return isCurrentLayout ? '#fff' : ''
  }
}

export const layoutStylesService = new LayoutStylesService()
